import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import "./VisualisationPage.css";

export default function VisualisationPage() {
  return (
    <main id="main" className="visualisation-page" data-testid="visualisation-page">
      <header className="visualisation-hero">
        <div className="visualisation-hero-inner">
          <span className="visualisation-eyebrow"><Sparkles size={13} /> Outil — Visualisation assistée par IA</span>
          <h1 className="visualisation-title">METTRE UNE IDÉE<br /><span>EN IMAGE.</span></h1>
          <p className="visualisation-intro">Les images de concept servent à cadrer l'échange avant l'étude. Elles ne constituent pas des plans.</p>
        </div>
      </header>
      <div className="visualisation-main">
        <p role="status">L'outil de génération est momentanément indisponible.</p>
        <Link to="/#contact" className="btn btn-primary">Décrire votre besoin à SI2T</Link>
      </div>
    </main>
  );
}
